import type { FlightType } from "@/types/flights";
import { RadioDropdown } from "./RadioDropdown/RadioDropdown";
import { getFlightTypeOptions } from "./useSearchFlights";
import { useTranslations } from "next-intl";

const isFlightType = (value: unknown): value is FlightType => {
  return value === "rounded" || value === "one_way" || value === "multi_city";
};

const getValue = (value: string): FlightType => {
  return isFlightType(value) ? value : "rounded";
};

type Props = {
  value: FlightType;
  onChange: (flightType: FlightType) => void;
  className?: string;
  isFullScreenModal?: boolean;
};

const FlightTypeDropdown = ({
  value,
  onChange,
  className,
  isFullScreenModal = false,
}: Props) => {
  const t = useTranslations();

  return (
    <RadioDropdown
      value={value}
      options={getFlightTypeOptions(t)}
      name="flightType"
      id="flight-type"
      onChange={(value) => onChange(getValue(value))}
      className={className}
      title="Flight type"
      isFullScreenModal={isFullScreenModal}
    />
  );
};

export default FlightTypeDropdown;
